<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

import codeEditorService from '@/services/embeds/plugin/code.editor.service'
const editor = ref<HTMLElement | null>(null)

onMounted(async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  codeEditorService.initCodeEditor(editor.value as HTMLElement)
  window.addEventListener('resize', codeEditorService.heightChangeFunction)
})
onBeforeUnmount(async () => {
  window.removeEventListener('resize', codeEditorService.heightChangeFunction)
  codeEditorService.destroyCodeEditor()
  await new Promise((resolve) => setTimeout(resolve, 100))
})
</script>

<template>
  <div ref="editor" :class="['block', 'min-w-full', 'rounded-lg']" />
</template>
